<template>
  <div class="fit">
    <div class="r-text-intro">נראה שעדיין לא נרשמת</div>
    <div class="r-text-headline-paragraph">לחיצה על הכפתור תיקח אותך להרשמה לחיסכון.</div>
    <default-button label='להרשמה' @click="moveToLightup" :loading="loading"/>
  </div>
</template>

<script>
import DefaultButton from '@/components/styled/DefaultButton';

export default {
  name: 'LoginMemberDoesNotExist',
  components: { DefaultButton },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async moveToLightup() {
      await this.$router.push({ path: '/lightup/hard-beginnings' });
    },
  },
};
</script>
